export default "__VITE_ASSET__a4c5bb68__"